module.exports = __webpack_public_path__ + "img/yml_gallery0.e81603f8.jpg";